import clsx from 'clsx'
import Image from 'next/image'
import React, { FC } from 'react'

import imgGuaranteeIcon from '@/screens/Product/page/assets/icon.png'

import { Popover } from '@/shared/ui/Popover'

import cl from './product-guarantee.module.scss'

interface ProductGuaranteeProps {
	className?: string
	yearText?: string
}

export const ProductGuarantee: FC<ProductGuaranteeProps> = ({ className }) => {
	return (
		<section className={cl.ProductGuarantee}>
			<Popover
				trigger="click"
				style={{ zIndex: `11` }}
				content={
					<div className={cl.ProductGuaranteeTooltip}>
						Уведомляем Вас об отсутствии в товарах марки Apple предустановленного приложения RuStore и иных программ
						согласно Распоряжению Правительства РФ от 25.07.2024 N 1972-р, а также невозможности их установки в
						настоящее время.
						<br />
						<br />В связи с отсутствием приложения RuStore Вы не можете устанавливать различные мобильные приложения,
						если они недоступны в фирменном магазине Apple, а также осуществлять их оплату при покупке приложений и
						обновления приложений в RuStore или иных, в т.ч. фирменных магазинах приложений на устройствах Apple
						{/*<Link href="/space" legacyBehavior>*/}
						{/*	<a target="_blank">Подробнее</a>*/}
						{/*</Link>*/}
					</div>
				}
				placement="bottomLeft">
				<div className={clsx(cl.GuaranteeLink, className)}>
					<Image src={imgGuaranteeIcon} alt="Без Rustore" width="30" height="30" />
					<span>
						<span>Без приложения RuStore</span>
					</span>
				</div>
			</Popover>
		</section>
	)
}
